<template>
  <div>
    <div class="d-flex justify-content-between align-center my-4 px-1">
      <!--      <span-->
      <!--        class="me-auto font-size-h4 font-weight-medium"-->
      <!--        style="color: rgba(0, 0, 0, 0.87)"-->
      <!--        >{{ $t(filter.name) + " " + $t("list") }}</span-->
      <!--      >-->
      <b-button-group class="ms-auto" size="md">
        <button
          @click="addRule"
          class="h-40px text-capitalize btn btn-light-info btn-hover-light"
          :disabled="currentQuery.length >= filter?.values.length"
        >
          <span class="svg-icon me-0">
            <v-icon size="24">mdi-bookmark-plus</v-icon>
          </span>
          {{ $t("add") }}
        </button>
      </b-button-group>
    </div>
    <template v-for="(item, index) in currentQuery">
      <Action
        :rule="item"
        :filter="filter"
        :availableItems="getAvailableItems(index)"
        :key="index"
        :index="index"
        :updateValues="updateSelectValues"
        :selectedReportNotificationType="selectedReportNotificationType"
        class="mt-2 px-1"
        ref="action"
      />
    </template>
  </div>
</template>

<script>
import Action from "@/own/components/settings/notifications/highValueShipmentBuilder/Action.vue";
export default {
  name: "ActionGroup",
  components: { Action },
  props: {
    currentQuery: {
      type: Array,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    selectedReportNotificationType: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {
    this.$nextTick(() => {
      if (this.currentQuery.length === 0) {
        this.addRule();
      }
    });
  },
  methods: {
    addRule() {
      const newGroup = {
        filterData: null,
        threshold: null,
      };
      this.currentQuery.push(newGroup);
    },
    updateSelectValues() {},
    getAvailableItems(rowIndex) {
      const allValues = this.filter?.values || [];
      // Collect all selected indices from every OTHER row
      const usedIndices = new Set();
      this.currentQuery.forEach((row, idx) => {
        if (idx === rowIndex) return;
        const selected = row.filterData;
        if (!selected) return;
        if (Array.isArray(selected)) {
          selected.forEach((v) => usedIndices.add(v));
        } else {
          usedIndices.add(selected);
        }
      });
      if (usedIndices.size === 0) return allValues;
      return allValues.filter((item) => !usedIndices.has(item.index));
    },
  },
  watch: {
    currentQuery: {
      handler() {
        this.updateSelectValues();
      },
      deep: true,
    },
  },
};
</script>
